module.exports = __webpack_public_path__ + "static/img/30009 (4).9662b7e.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30009 (4).webp
// module id = wx8j
// module chunks = 14